<template>
   <div class="container-fluid not-estimated-page">
     <div class="title-container">
       <h3 class="title">
         Not budget tasks
         <div
           class="spinner-border spinner-theme_default"
           role="status"
           v-if="isDataPageLoading"
         >
                <span class="sr-only">
                  Loading...
                </span>
         </div>
       </h3>
       <div class="title-container__controls">
         <b-button
           class="button title-container__controls-item"
           :variant="isShowFilter ? 'secondary' : 'info'"
           @click="toggleShowFilter"
         >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
           Filters
         </b-button>
       </div>
     </div>

     <Filters
       v-show="isShowFilter"
       textButtonSubmit="Get Report"
       :data="filters"
       :isLoading="isDataPageLoading"
       @submit="getNotBudget"
     />

     <TableForPage
       ref="table"
       class="not-estimated-table"
       v-if="notBudgetTasks.length"
       :slots="table.slots"
       :tableData="notBudgetTasks"
       :fields="table.fields"
     >
       <template v-slot:project_name="data">
         <a :href="data.item.project_url" target="_blank">
           <img
             class="project-icon"
             :src="data.item.project_icon"
             :alt="data.item.project_name"
           >
           {{data.item.project_name}}
         </a>
       </template>
       <template v-slot:key="data">
         <a :href="'https://giraffesoftware.atlassian.net/browse/' + data.item.key" target="_blank">
           {{ data.item.key }}
         </a>
       </template>
       <template v-slot:type="data">
         <img class="issue-icon" :src="data.item.issue_type_icon" :alt="data.item.key">
         <span>{{ data.item.type }}</span>
       </template>
     </TableForPage>
  </div>
</template>

<script>
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'

export default {
  name: 'NotBudget',
  components: {
    Filters,
    TableForPage
  },
  data () {
    return {
      isShowFilter: true,
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          value: null,
          class: 'col-md-3'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          value: null,
          class: 'col-md-3'
        },
        'projects': {
          type: 'select',
          name: 'project',
          label: 'Projects',
          selectLabel: 'name',
          valueField: 'key',
          options: [],
          class: 'col-md-3'
        },
        'issue_type': {
          type: 'select',
          name: 'issue_type',
          label: 'Issue type',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          class: 'col-md-3'
        },
        'issue_status': {
          type: 'select',
          name: 'status',
          label: 'Status',
          selectLabel: 'name',
          valueField: 'name',
          options: [],
          class: 'col-md-3'
        },
        'assignee': {
          type: 'select',
          name: 'assignee',
          label: 'Assignee',
          selectLabel: 'name',
          valueField: 'name',
          options: [],
          class: 'col-md-3'
        },
        'project_manager': {
          type: 'select',
          name: 'project_manager',
          label: 'Project manager',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          class: 'col-md-3'
        }
      },
      table: {
        slots: {
          project_name: {
            name: 'project_name'
          },
          key: {
            name: 'key'
          },
          type: {
            name: 'type'
          }
        },
        fields: [
          {
            key: 'project_name',
            label: 'Project'
          },
          {
            key: 'key',
            label: 'Issue'
          },
          {
            key: 'type',
            label: 'Issue type'
          },
          {
            key: 'status.name',
            label: 'Status'
          },
          {
            key: 'assignee.displayName',
            label: 'Assignee'
          },
          {
            key: 'project_manager_name',
            label: 'Project manager'
          },
          {
            key: 'reporter_name',
            label: 'Reporter'
          },
          {
            key: 'last_update',
            sortable: true,
            label: 'Date updated'
          }
        ]
      },

      isDataPageLoading: false
    }
  },
  computed: {
    ...mapGetters({
      getAllUsers: 'getAllUsers',
      getProjects: 'projects/getProjects',
      getProjectManagers: 'users/getProjectManagers',
      getIssueTypes: 'getIssueTypes',
      getIssueStatuses: 'getIssueStatuses'
    }),
    notBudgetTasks () {
      return this.$store.getters.getNotBudgetIssues || []
    }
  },
  created () {
    this.fetchAllData()
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    getNotBudget (fields) {
      const data = this.prepareDataForGetNotBudget(fields)

      this._toggleDataPageLoading(async () => {
        await this.$api.notBudget.fetchNotBudgetTasks(data)
        this.resetPagination()
      })
    },
    prepareDataForGetNotBudget (fields) {
      let newFields = fields
      let data = {}

      newFields.date_from.value = this._toLocalTime(newFields.date_from.value)
      newFields.date_to.value = this._toLocalTime(newFields.date_to.value)

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => {
            return {
              [fields[key].nameItem]: item.id
            }
          })
        }

        data[name] = value
      }

      return data
    },
    fetchAllData () {
      Promise.all([
        this.fetchAllUsers(),
        this.fetchAllProjects(),
        this.fetchProjectManagers(),
        this.fetchIssueTypes(),
        this.fetchIssueStatuses(),
        this.getNotBudget(this.filters)
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    async fetchAllProjects () {
      if (this.getProjects.length) return

      await this.$api.projects.getProjects()
    },
    async fetchProjectManagers () {
      if (this.getProjectManagers.length) return

      await this.$api.users.getProjectManagers()
    },
    async fetchAllUsers () {
      if (this.getAllUsers.length) return

      return this.$api.users.getAllUsers()
    },
    async fetchIssueTypes () {
      if (this.getIssueTypes.length) return

      return this.$api.issues.getIssueTypes()
    },
    async fetchIssueStatuses () {
      if (this.getIssueStatuses.length) return

      return this.$api.issues.getIssueStatuses()
    },

    setAllOptionsFilter () {
      this.filters.projects.options = this.getProjects
      this.filters.issue_type.options = this.getIssueTypes
      this.filters.issue_status.options = this.getIssueStatuses
      this.filters.assignee.options = this.getAllUsers
      this.filters.project_manager.options = this.getProjectManagers
    }
  }
}
</script>

<style lang="scss" >
.not-estimated-page {
    .spinner-border {
        position: relative;
        top: 0;
    }

    .not-estimated-table {

        max-height: calc(100vh - 200px);

        .issue-icon {
            position: relative;
            top: -2px;
            margin-right: 3px;
        }

        .project-icon {
            position: relative;
            max-width: 20px;
            top: -2px;
            margin-right: 5px;
        }
    }
}

</style>
